export default "__VITE_ASSET__C1qLCa6I__"